'use client'

import { useEffect, useState } from 'react'
import { CookieConsent } from '@/components/CookieConsent'
import { AnalyticsScripts } from '@/components/AnalyticsScripts'

type CookiePreferences = { analytics: boolean }

const COOKIE_NAME = 'cookie-preferences'

function readPrefsFromCookie(): CookiePreferences | null {
  if (typeof document === 'undefined') return null
  const cookie = document.cookie.split('; ').find((row) => row.startsWith(`${COOKIE_NAME}=`))
  if (!cookie) return null
  try {
    return JSON.parse(decodeURIComponent(cookie.split('=')[1]))
  } catch {
    return null
  }
}

export default function ConsentProvider() {
  const [prefs, setPrefs] = useState<CookiePreferences | null>(null)

  useEffect(() => {
    const saved = readPrefsFromCookie()
    setPrefs(saved)
  }, [])

  const handlePreferencesChange = (newPrefs: CookiePreferences) => {
    setPrefs(newPrefs)
    try {
      window.dispatchEvent(new CustomEvent('cookie-preferences-changed', { detail: newPrefs }))
    } catch {
      console.error('Something went wrong')
    }
  }

  const analyticsAllowed = !!prefs?.analytics

  return (
    <>
      {analyticsAllowed && <AnalyticsScripts />}
      <CookieConsent onPreferencesChange={handlePreferencesChange} />
    </>
  )
}
